import React from "react";
import Layout from "../components/Layout";

const Email = () => {
  return <Layout>Email</Layout>;
};

export default Email;
